import WorkoutAssignmentNotification from './WorkoutAssignmentNotification';

export default WorkoutAssignmentNotification;
